import React, { memo, useMemo } from 'react';

import { Box, Typography } from '@mui/material';
import PropTypes from 'prop-types';

import { CALL_CONTROL_ICON_SIZE } from '../../MobileCallSurface.constants';
import {
  controlButtonActiveStyles,
  controlButtonStyles,
  controlCellStyles,
  controlLabelStyles,
} from '../../MobileCallSurface.styles';

const CallControlButton = ({
  icon: Icon,
  label,
  isActive = false,
  isDisabled = false,
  onPress,
}) => {
  const buttonStyles = useMemo(
    () => (isActive ? controlButtonActiveStyles : controlButtonStyles),
    [isActive],
  );

  return (
    <Box sx={controlCellStyles}>
      <Box
        aria-label={label}
        aria-pressed={isActive}
        component="button"
        data-testid={`mobile-call-control-${label}`}
        disabled={isDisabled}
        sx={buttonStyles}
        onClick={onPress}
      >
        <Icon size={CALL_CONTROL_ICON_SIZE} />
      </Box>
      <Typography sx={controlLabelStyles} variant="regular12">
        {label}
      </Typography>
    </Box>
  );
};

CallControlButton.propTypes = {
  icon: PropTypes.elementType.isRequired,
  label: PropTypes.string.isRequired,
  onPress: PropTypes.func.isRequired,
  isActive: PropTypes.bool,
  isDisabled: PropTypes.bool,
};

export default memo(CallControlButton);
